module.exports = __webpack_public_path__ + "static/media/gamePlumbing.8fdf8264.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gamePlumbing.png
// module id = 2294
// module chunks = 0